import { BaseError } from '@/common';
import { IMetricEventsDataSource, IMetricEventsRepository, MetricEvent } from '@/features';
import { Either, left, right } from 'fp-ts/lib/Either';

export class MetricEventsRepository implements IMetricEventsRepository {
  dataSource: IMetricEventsDataSource;

  constructor(dataSource: IMetricEventsDataSource) {
    this.dataSource = dataSource;
  }

  async createEvent(event: MetricEvent): Promise<Either<BaseError, string>> {
    try {
      const response = await this.dataSource.createEvent(event);
      return right(response);
    } catch (error) {
      if (error instanceof BaseError) {
        return left(error);
      }

      return left(new BaseError('Failed to create metric event'));
    }
  }
}
